module.exports = __webpack_public_path__ + "static/media/seguradora_essor.a02f181f.png";